import { render } from "./Item4.vue?vue&type=template&id=a8ec44d4&scoped=true"
import script from "./Item4.vue?vue&type=script&lang=js"
export * from "./Item4.vue?vue&type=script&lang=js"

import "./Item4.vue?vue&type=style&index=0&id=a8ec44d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8ec44d4"

export default script